import React, {
    useContext,
    useEffect,
    useState,
} from "react";
import {useLocation} from "react-router-dom";

import {mainConfig} from "../../config";
import {AppContext} from "../../contexts/app-context";
import {
    useThemePreference,
} from "../../presentation/theme/use-theme-preference";
import {
    isPlatformNewsPath,
} from "../../presentation/public-site/route-policy";
import LanguageSwitcher from "../header/LanguageSwitcher";
import PlatformNewsLink from "../header/PlatformNewsLink";
import DesktopNavigation from "./DesktopNavigation";
import MobileMenuButton from "./MobileMenuButton";
import MobileNavigation from "./MobileNavigation";
import ProfileBlock from "./ProfileBlock";
import SubMenu from "./SubMenu";
import ThemeSwitcher from "./ThemeSwitcher";

function TopMenu({
                     items,
                     user,
                     onUserTypeChanged,
                 }) {
    const appContext = useContext(AppContext);
    const location = useLocation();

    const [isMenuOpen, setMenuOpen] = useState(false);
    const isGuestUser = !user || user.isGuest();

    const {
        theme,
        isDarkTheme,
        setTheme,
    } = useThemePreference();

    useEffect(() => {
        setMenuOpen(false);
    }, [location.pathname]);

    const handleNavigate = (path) => {
        appContext.setCurrentPath(path);
    };

    const handleMobileNavigate = (path) => {
        handleNavigate(path);
        setMenuOpen(false);
    };

    return (
        <div
            className={`container header-shell__content${
                isMenuOpen
                    ? " header-shell__content--menu-open"
                    : ""
            }`}
        >
            <div className="header__block header__block--top">
                <a href="/" className="logo">
                    <img
                        src="/img/svg/logo.svg"
                        alt={mainConfig.companyName}
                    />
                </a>

                <DesktopNavigation
                    items={items}
                    currentPath={location.pathname}
                    onNavigate={handleNavigate}
                />

                <div
                    className={`head-login${
                        isGuestUser
                            ? " head-login--guest"
                            : ""
                    }`}
                >
                    <ProfileBlock
                        user={user}
                        isDarkTheme={isDarkTheme}
                        onLogout={appContext.logout}
                        onUserTypeChanged={onUserTypeChanged}
                    />
                </div>
            </div>

            <div className="header__block header__block--bottom">
                <MobileMenuButton
                    opened={isMenuOpen}
                    onToggle={() =>
                        setMenuOpen((opened) => !opened)
                    }
                />

                <div className="head-nav bottom-menu">
                    <SubMenu user={user}>
                        <li
                            className={
                                isPlatformNewsPath(location.pathname)
                                    ? "active"
                                    : ""
                            }
                        >
                            <PlatformNewsLink className="header__news-link"/>
                        </li>
                    </SubMenu>
                </div>

                <div
                    className={`header__utility-actions${
                        isDarkTheme
                            ? " header__utility-actions--dark"
                            : ""
                    }`}
                >
                    <LanguageSwitcher/>

                    <ThemeSwitcher
                        theme={theme}
                        onChange={setTheme}
                    />
                </div>
            </div>

            <MobileNavigation
                opened={isMenuOpen}
                items={items}
                user={user}
                currentPath={location.pathname}
                onNavigate={handleMobileNavigate}
                onClose={() => setMenuOpen(false)}
            />
        </div>
    );
}

export default TopMenu;
